<div class="comment" *ngFor="let c of thread" data-testid="comment">
  <div class="indent-guide mr-3" [attr.data-testid]="'depth-' + depth">
    <div class="indent-guide-circle" [ngStyle]="depthStyle"></div>
    <div class="indent-guide-line" [ngStyle]="depthStyle"></div>
  </div>
  <div class="main">
    <!-- top ----------------------------------------------------------------- -->
    <div class="top">
      <div class="body">
        <div class="d-flex align-items-baseline">
          <p
            class="name mat-body-2 mb-0 lh-1 d-inline-block"
            data-testid="author"
          >
            {{ c.author }}
          </p>
          <div class="day mat-caption ml-2 text-muted" data-testid="date">
            {{ c.date | date: 'short' }}
          </div>
        </div>
        <div class="content" [innerHTML]="c.body"></div>
      </div>
      <div class="ml-3 actions">
        <button mat-icon-button color="primary" data-testid="reply-button">
          <am-icon name="message-plus"></am-icon>
        </button>
      </div>
    </div>
    <!-- /top ---------------------------------------------------------------- -->

    <ng-container *ngIf="c.children && c.showChildren !== false">
      <div class="replies" data-testid="replies">
        <am-thread [thread]="c.children" [depth]="depth + 1"></am-thread>
      </div>
    </ng-container>
  </div>
</div>
